import styled from 'styled-components'

export const OutlineContainer = styled.div`
width: 100%;
border-radius: 4px;
padding: 1rem;
display: flex;
flex-direction: column;
border: 1px solid var(--${props => props.theme});
`
